/* eslint-disable */
// @ts-nocheck

import { useNavigate } from "react-router-dom";
import React, { useState, useEffect, useContext } from "react";
import { Spin } from "antd";
import { PageTitle } from "../../components/PageTitle";
import { JobsListComponent } from "../../components/shared/chat/features";
import { MainContainer } from "../../components/shared/chat";
import { AuthContext } from "../../context/AuthContext";
import { getSilverAgentJobs } from "../../services/api";
import { transformSilverAgentJobs, TransformedAiJob } from "../../utils/silverAgentJobsTransformer";
import {SilverButton} from "../../components/LayoutWrapperCandidate.tsx";
import styled from "styled-components";
import { AiPreview } from "../aiPreview/AiPreview";
import aiJobsImg from "../../assets/aijobs.jpg";

export const AiNewJobs = () => {
    const navigate = useNavigate();
    const [jobs, setJobs] = useState<TransformedAiJob[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    // Get subscription status
    const { canAccess } = useContext(AuthContext);
    const hasActiveSubscription = canAccess('ai-jobs');

    // Custom job click handler - redirect to silverplus if not subscribed
    const handleJobClick = (jobId: string) => {
        if (!hasActiveSubscription) {
            navigate('/silverplus');
        } else {
            navigate(`/jobs/${jobId}`);
        }
    };

    // Fetch jobs on component mount (only if subscribed)
    useEffect(() => {
        if (!hasActiveSubscription) {
            setIsLoading(false);
            return;
        }

        const fetchJobs = async () => {
            try {
                setIsLoading(true);
                setError(null);

                const response = await getSilverAgentJobs();
                const transformedJobs = transformSilverAgentJobs(response);

                setJobs(transformedJobs);
            } catch (err) {
                console.error('Error fetching Silver Agent jobs:', err);
                setError('Fehler beim Laden der Jobs. Bitte versuchen Sie es später erneut.');
            } finally {
                setIsLoading(false);
            }
        };

        fetchJobs();
    }, [hasActiveSubscription]);

    if (isLoading) {
        return (
            <div>
                <PageTitle title="Jobs aus dem Web" />
                <MainContainer>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '50vh',
                        flexDirection: 'column',
                        gap: '16px'
                    }}>
                        <Spin size="large" />
                        <div style={{ fontSize: '16px', color: '#666' }}>
                            Lade neue Jobs...
                        </div>
                    </div>
                </MainContainer>
            </div>
        );
    }

    if (!hasActiveSubscription) {
        return (
            <div>
                <MainContainer>
                    <div style={{
                        position: 'relative',
                        height: 'calc(100vh - 100px)',
                        borderRadius: 12,
                        overflow: 'hidden',
                    }}>
                        <img src={aiJobsImg} alt="AI Jobs" style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            position: 'absolute',
                            top: 0,
                            left: 0,
                        }} />
                        <div style={{ position: 'relative', zIndex: 1, height: '100%' }}>
                            <AiPreview />
                        </div>
                    </div>
                </MainContainer>
            </div>
        );
    }

    return (
        <div>
            <PageTitle title="Jobs aus dem Web" />
            <MainContainer>
                    {error && (
                        <div style={{
                            padding: '20px',
                            background: '#fff2f0',
                            border: '1px solid #ffccc7',
                            borderRadius: '8px',
                            color: '#ff4d4f',
                            marginBottom: '16px'
                        }}>
                            {error}
                        </div>
                    )}

                    <SilverWrapper>
                        <p>
                            Wir aktualisieren für Sie die Jobvorschläge alle 3 Tage automatisch.
                            Nichts Passendes dabei? Verfeinern Sie die Suche mit unserer KI Jobsuche
                        </p>
                        <SilverButton
                            type="primary"
                            size="large"
                            style={{width: 300}}
                            onClick={()=>navigate("/ai-jobs")}
                        >
                            zur Jobsuche mit KI
                        </SilverButton>
                    </SilverWrapper>
                    <JobsListComponent
                        state={{
                            showJobsList: true,
                            matchedJobs: jobs,
                            isLoadingJobs: false,
                            jobsError: error
                        }}
                        onJobClick={handleJobClick}
                        requiresSubscription={!hasActiveSubscription}
                    />
            </MainContainer>
        </div>
    );
};

const SilverWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 16px;
`
